'use client';

import { useEffect, useState } from 'react';

import { LANGUAGE_COOKIE } from '../../utils/standardSprachen';
import FehlerSeite from './FehlerSeite';
import { cookieWert, praefixAusPfad, waehleSprache } from './sprache';
import { SPRACHEN, uebersetzer } from './texte';

/**
 * Die Fehlerseite im Browser (`error.tsx`, `global-error.tsx`): Sprache aus
 * Adresse, Cookie und Browser, Texte aus dem mitgelieferten Auszug.
 *
 * Gewählt wird erst nach dem Einhängen — beim Rendern auf dem Server gibt es
 * weder `document.cookie` noch `navigator`, und eine Wahl, die zwischen Server
 * und Browser verschieden ausfällt, ist ein Hydration-Fehler. Bis dahin steht
 * nichts da; ohne JavaScript bleibt die Seite deshalb leer (bekannt, benannt).
 */
export default function ClientFehlerSeite({ error }: { error: unknown }) {
  const [ort, setOrt] = useState<{ sprache: string; praefix: string } | null>(null);

  useEffect(() => {
    // Laut: Eine Fehlerseite ist ein Ereignis, das jemand untersuchen muss (Regel #7).
    console.error('Fehlerseite:', error);
  }, [error]);

  useEffect(() => {
    const pfad = window.location.pathname;
    const sprache = waehleSprache(SPRACHEN, {
      pfad,
      cookie: cookieWert(document.cookie, LANGUAGE_COOKIE),
      browser: navigator.languages,
    });
    setOrt({ sprache, praefix: praefixAusPfad(pfad)?.praefix ?? '' });
    // Ein Root-Layout trägt `lang="de"`, bis die App es setzt; englischer
    // Text darf nicht als Deutsch ausgezeichnet sein (Vorlesegeräte).
    document.documentElement.lang = sprache;
  }, []);

  if (ort === null) return null;
  return (
    <FehlerSeite
      t={uebersetzer(ort.sprache)}
      art="fehler"
      praefix={ort.praefix}
      neuLaden={() => window.location.reload()}
    />
  );
}
